import { render, staticRenderFns } from "./StepPage.vue?vue&type=template&id=22060410&scoped=true&"
import script from "./StepPage.vue?vue&type=script&lang=js&"
export * from "./StepPage.vue?vue&type=script&lang=js&"
import style0 from "./StepPage.vue?vue&type=style&index=0&id=22060410&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22060410",
  null
  
)

export default component.exports